<template>
  <div class="jobs-create jjobs-create" v-loading="loading" style="padding-top: 20px">
    <el-form>
      <div style="width: 100%" v-if="(!$route.params.type || $route.params.type  === 'JOB')">
      <span class="obj-name" v-if="object">
        Выбранный объект: <strong>{{ ` ` + object.name }}</strong>
      </span>
        <AddObjects
          v-if="!obj"
          :confirmDisable="true"
          :isSelect="!!object"
          @add-objects="(n) => object = n"
        />
      </div>
      <el-form-item label="Тип" class="select-type" v-if="!$route.params.type">
        <el-select v-model="form.type">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Название">
        <el-input v-model="form.name" placeholder="Название"/>
      </el-form-item>
      <div v-if="$route.params.type !=='TECH' && $route.params.type !=='PROF'">
        <el-form-item :label="`${this.$route.query.plan ? 'Месячные объемы' : 'Проектные объемы'}`">
          <el-input v-if="this.$route.query.plan" type="number"
                    v-model="form.plan" @input="inputUnitPrice"
                    @blur="(v) =>form.plan = formatNumber(form.plan)"
                    placeholder="Проектные объемы">
            <Volumes
              :plan="form.plan"
              type="JOB"
              :table="form.volumes || []"
              slot="suffix" :jobName="form.name" @save="saveVolumes"/>
          </el-input>
          <el-input v-else type="number" v-model="form.plan" @input="setPrice" placeholder="Проектные объемы">
          </el-input>
        </el-form-item>
        <unit-select v-model="form.unit"/>
      </div>
      <div v-else-if="$route.params.type">
        <filter-select
          v-model="form.kind"
          label="Вид"
          :options="options_units[$route.params.type.toLowerCase()]"
        />
      </div>
      <div v-if="!$route.params.type || $route.params.type === 'JOB' || type_prop === 'JOB' ">
        <filter-select
          v-model="form.work_type"
          label="Вид работы"
          :options="options_works"
        />

        <!--        <el-form-item label="Вид работы">-->
        <!--          <el-select v-model="form.work_type">-->
        <!--            <el-option-->
        <!--              v-for="item in options_works"-->
        <!--              :key="item.name"-->
        <!--              :label="item.name"-->
        <!--              :value="item.id"-->
        <!--            >-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item> deadline_accounting-->
      </div>
      <div v-if="permission.price  && $route.params.type !=='TECH' && $route.params.type !=='PROF'">
        <el-form-item :label="`План ${permission.price && permission.unit_name  || 'стоимость'}`">
          <el-input type="number" v-model="form.price_plan" @input="setPrice"
                    :placeholder="`План ${permission.price && permission.unit_name || 'стоимость'}`"/>
        </el-form-item>
        <el-form-item :label="`${permission.price && permission.unit_name || 'Стоимость'} на ед. объема`">
          <el-input type="number" v-model="form.price_unit" @input="inputUnitPrice"
                    :placeholder="`${permission.price && permission.unit_name || 'Стоимость'} на ед. объема`"/>
        </el-form-item>
      </div>


      <el-form-item label="ФОТ на ед. объема" v-if="$store.state.project.is_fot">
        <el-input
          v-model="form.unit_fot"
          type="number"
          placeholder="ФОТ на ед. объема"></el-input>
      </el-form-item>


      <div v-if="this.$route.query.plan">

        <el-form-item label="Дата начала работ">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            v-model="form.project.start_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Дата окончания работ по проекту">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            v-model="form.project.end_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="План объемы по проекту">
          <el-input
            v-model="form.project.plan_volume"
            @blur="(v) =>form.project.plan_volume = formatNumber(form.project.plan_volume)"
            placeholder="План объемы по проекту "></el-input>
        </el-form-item>

        <el-form-item label="Факт объемы по проекту">
          <el-input
            v-model="form.project.fact_volume"
            @blur="(v) =>form.project.fact_volume = formatNumber(form.project.fact_volume)"
            placeholder="Факт объемы по проекту"></el-input>
        </el-form-item>

        <el-form-item label="Месячный план по технике">
          <el-input type="number" :value="form.plan_tech" @input="setPrice">
            <AddProfTech
              :table="form.volumes_tech || []"
              type="TECH" slot="suffix" @save="(v) => saveVolumes(v, 'TECH')"/>
          </el-input>
        </el-form-item>
        <el-form-item label="Месячный план по числености">
          <el-input type="number" :value="form.plan_prof">
            <AddProfTech
              :table="form.volumes_prof || []"
              type="PROF" slot="suffix" @save="(v) => saveVolumes(v, 'PROF')"/>
          </el-input>
        </el-form-item>
      </div>

      <template v-if="this.$route.query.version">
        <PermissionObjectVersion
          :version="form.permission[$store.state.project.plan && $store.state.project.plan.id || null]"
          :name="$route.query.name"
          :planId="$store.state.project.plan && $store.state.project.plan.id"
          @update="(permission) => form.permission[$store.state.project.plan && $store.state.project.plan.id || null] = {
            ...form.permission[$store.state.project.plan && $store.state.project.plan.id || null],
            ...permission
          }">
          <el-button style="width: 100%; ">Привязка к работам</el-button>
        </PermissionObjectVersion>
        <PermissionZonesVersion
          :version="form.permission[$store.state.project.plan && $store.state.project.plan.id || null]"
          @update="(permission) => form.permission[$store.state.project.plan && $store.state.project.plan.id || null] = {
            ...form.permission[$store.state.project.plan && $store.state.project.plan.id || null],
            ...permission
          }"
        >
          <el-button style="width: 100%; margin-top: 12px; margin-left: 0">Привязка к зонам Работ</el-button>
        </PermissionZonesVersion>
        <filter-select
          multiple
          :value="form.permission[$store.state.project.plan && $store.state.project.plan.id || null].available_companies || []"
          @input="(permission) => form.permission[$store.state.project.plan && $store.state.project.plan.id || null] = {
            ...form.permission[$store.state.project.plan && $store.state.project.plan.id || null],
            available_companies: permission
          }"
          label="Отчеты по исполнителям"
          :options="options_companies"
        />
      </template>

      <div
        v-if="permission.deadline_accounting  && $route.params.type !=='TECH' && $route.params.type !=='PROF'">
        <el-form-item label="Дата начала работы">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            @change="changeDate"
            v-model="form.start_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Дата окончаниия работы">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            @change="changeDate"
            v-model="form.end_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>
      </div>

      <div v-for="inp in form.inputs" :key="inp.label">
        <el-form-item :label="inp.label">
          <el-input v-model="inp.value" placeholder="" :type="inp.type === 'number' ? 'number' : 'text'"/>
        </el-form-item>
      </div>
      <div class="jobs-create__buttons">
        <el-button v-if="$route.name !== 'JobEdit'" @click="close">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="$route.name !== 'JobEdit'" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit">Редактировать</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import FilterSelect from '../../../components/FilterSelect';
import work_units from '../../../data/work_units';
import AddObjects from '../Reports/components/AddObjects';
import UnitSelect from '../components/unitSelect';
import {getUnits} from '../../../firestore/units';
import {fetchObjectsWithParent} from "../../../firestore/objects";
import {BigNumber} from "bignumber.js";
import dayjs from "dayjs";
import Volumes from "./components/Volumes";
import AddProfTech from "./components/AddProfTech";
import {toFixedWithoutZero, toFloat} from "../../../utils/numberUtils";
import PermissionObjectVersion from "./components/PermissionObjectVersion";
import PermissionZonesVersion from "./components/PermissionZoneVersion";
import {getUsersOptions} from "../../../firestore/users";
import _ from "lodash";

export default {
  name: 'Create',
  props: {
    isNested: Boolean,
    obj: String,
    type_prop: String,
  },
  components: {
    PermissionZonesVersion,
    PermissionObjectVersion, AddProfTech, Volumes, UnitSelect, AddObjects, FilterSelect
  },
  data() {
    return {
      options_units: work_units,
      loading: false,
      checked: false,
      object: null,
      options_companies: [],
      version: null,
      form: {
        inputs: [],
        unit_fot: '',
        name: '',
        plan: '',
        start_date: null,
        end_date: null,
        type: this.type_prop || this.$route.params.type || '',
        unit: '',
        unit_id: null,
        project: {
          end_date: null,
          start_date: null,
          plan_volume: null,
          fact_volume: null,
        },
        work_type: null,
        volumes: [],
        kind: null,
        price_plan: null,
        permission: {},
        price_unit: null,
        volumes_prof: [],
        ids_prof: [],
        ids_tech: [],
        volumes_tech: [],
        plan_tech: 0,
        plan_prof: 0
      },
      options_works: [],
      options: [
        {
          value: 'JOB',
          label: 'Работы',
        },
        {
          value: 'TECH',
          label: 'Техника',
        },
        {
          value: 'PROF',
          label: 'Профессия',
        },
      ],
    };
  },

  async mounted() {
    if (this.$route.query.version) {
      this.form.permission = {
        [this.$store.state.project.plan && this.$store.state.project.plan.id || null]: {
          available_jobs: {},
          available_objects: [],
          available_zones: [],
          available_companies: [],
        }
      }

      this.version = (await this.fire().get()).data();

    }

    this.options_units = {
      ...this.options_units,
      main: await getUnits(this.$store.state.project.id),
    };

    let req = null;
    const result = [];
    const where = ((this.type_prop || this.$route.params.type) ? ((this.type_prop && this.type_prop.toLowerCase())
      || this.$route.params.type.toLowerCase()) : 'job')

    if(this.$route.query.version) {
      req = this.fire()
        .collection('works_type')
        .where('type', 'in', [where, where.toUpperCase()]
        );
    } else {
      req = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .where('type', 'in', [where, where.toUpperCase()]
        );
    }

    if (this.obj) {
      this.getObject(this.obj);
    } else {

    }

    await req.get()
      .then((data) => {
        data.forEach((subDoc) => {
          const data = subDoc.data();
          result.push({
            value: subDoc.id,
            label: data.name,
          });
        });
      })
      .finally(() => {
        this.options_works = [
          {
            label: 'Не выбрано',
            value: null,
          },
          ...result,
        ];

        console.log(  this.options_works)
        this.loader = false;
      });

    if (this.$route.name === 'JobEdit') {
      this.fire()
        .collection('jobs').doc(this.$route.params.id).get().then((data) => {
          console.log(data, 'data3423')

        const subData = data.data();

        const unit = this.options_units.main.find((f) => f.label === subData.unit || f.value === subData.unit_id);

        if (subData.objects[0]) {
          this.getObject(subData.objects[0]);
        }

        let work_type = this.options_works.find((e) => e.value === subData.work_type);

        if (!subData.work_type && subData.work_type_name && subData.work_type_name.length) {
          work_type = this.options_works.find((e) => e.label === subData.work_type_name);
        }


        if (!work_type) {
          work_type = null;
        }

        this.form = {
          ...this.form,
          ...subData,
          permission: {
            ...this.form.permission,
            ...subData.permission
          },
          plan: toFixedWithoutZero(subData.plan),
          price_plan: toFixedWithoutZero(subData.price_plan),
          work_type,
          unit,
        };
      });


    } else {
      if (this.$route.params.id) {
        this.getObject(this.$route.params.id);
      } else {
      }
    }


    if (this.$route.query.version) {
      const companies = await getUsersOptions(this.$store.state.project.id, true)

      this.options_companies = companies.filter(({_data}) => {
        return _data.isCompany
      }).map(({label, value}) => {
        return {label, value}
      })
    }

    await this.getInputs()

  },

  computed: {
    permission() {
      if(this.$route.query.list) {
        return this.$store.getters.permission || {}
      }

      if (this.$route.query.version) {
        return this.version || {}
      }

      return this.$store.getters.permission || {}
    }
  },

  methods: {
    formatNumber(v) {
      return toFloat(v)
    },
    inputUnitPrice() {
      this.form.price_plan = new BigNumber(this.form.plan || 0).multipliedBy(this.form.price_unit || 0).toNumber();
    },
    fire() {
      if (this.$route.query.version) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      if (this.$route.query.plan) {
        return firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan)
      }


      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    saveVolumes(volumes, type) {
      if (type === 'PROF') {
        this.form.plan_prof = volumes.total;
        this.form.volumes_prof = volumes.table;
      } else if (type === 'TECH') {
        this.form.plan_tech = volumes.total;
        this.form.volumes_tech = volumes.table;
      } else {


        this.form.plan = volumes.total;
        this.form.volumes = volumes.table;
      }

      this.inputUnitPrice()
    },
    changeDate() {
      const start = dayjs(this.form.start_date).unix();
      const end = dayjs(this.form.end_date).unix();

      if (start && end && start > end) {
        this.form.start_date = null;
        this.$notify.error({title: 'Ошибка', message: 'Дата начала должна быть не позднее даты окончания'});
      }
    },
    setPrice() {
      this.form.price_unit = new BigNumber(this.form.price_plan || 0).div(this.form.plan || 0).toNumber()
    },
    async getObject(id) {
      try {

        this.object = await fetchObjectsWithParent(id, this.$store.state.project.id, this.$route.query.plan, this.$route.query.version);
      } catch (e){}

      // this.form.inputs =
    },

    async getInputs(id = 'all') {
      const objects = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .where(`objects`, 'array-contains-any', ['all'])
        .get()


      const inputs = []
      objects.forEach((d) => {
        const data = d.data()
        const same = this.form.inputs.find((t) => {
          return  t.id === d.id
        })


        inputs.push({
          label: data.name,
          id: d.id,
          value: (same && same.value) || '',
          type: data.type.value,
          index: data.index,
          show: data.showReports.includes('all')
        })
      })


      this.form.inputs = _.orderBy(inputs, 'index', ['asc']);

    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        this.fire()
          .collection('jobs')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
            this.$router.go(-1);
          });
      });
    },
    close() {
      if (!this.isNested) {
        this.$router.go(-1);
      }
      this.$emit('close');
    },

    edit() {
      let work_type = null;
      if (this.form.work_type && this.form.work_type.value) {
        work_type = this.options_works.find((opt) => opt.value === (this.form.work_type && this.form.work_type.value));
      }
      const objectID = (this.object && this.object.id);
      this.loading = true;

      this.fire()
        .collection('jobs').doc(this.$route.params.id)
        .update({
          price_plan: this.form.price_plan,
          price_unit: this.form.price_unit,
          name: this.form.name,
          plan: this.form.plan,
          type: this.form.type,
          permission: this.form.permission,
          project: this.form.project,
          inputs: this.form.inputs || [],
          ids_prof: this.form.volumes_prof.map((d) => d.id),
          ids_tech: this.form.volumes_tech.map((d) => d.id),
          volumes: this.form.volumes || [],
          volumes_tech: this.form.volumes_tech || [],
          volumes_prof: this.form.volumes_prof || [],
          plan_prof: this.form.plan_prof || 0,
          unit_fot: this.form.unit_fot,
          plan_tech: this.form.plan_tech || 0,
          kind: this.form.kind,
          planID: (this.$route.query.plan) || null,
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          objects: [objectID || 'all'],
          unit: this.form.unit && this.form.unit.label || null,
          unit_id: this.form.unit && this.form.unit.value || null,
          work_type: (this.form.work_type && this.form.work_type.value) || '',
          work_type_name: work_type && work_type.label || '',
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Работа отредактирована',
          type: 'success',
        });

        let prefix = 'JOB'
        Object.keys(localStorage)
          .filter(key => key.startsWith(prefix))
          .map(key => localStorage.removeItem(key))


        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    async save() {
      // this.loading = true;
      const objectID = (this.object && this.object.id);

      let objects = this.$route.params.id === 'new' || this.checked ? [objectID || 'all'] : [objectID || this.obj || this.$route.params.id || 'all'];

      if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF') {
        objects = ['all'];
      }
      let work_type = this.options_works.find((opt) => opt.value === (this.form.work_type && this.form.work_type.value));

      if (!this.form.work_type || !this.form.work_type.value) {
        work_type = null;
      }

      const form = {...this.form};
      delete form.job;

      const jobs_s_r = await this.fire()
        .collection('jobs')
        .orderBy("index", 'desc').limit(1)
        .get();

      let jobs_s = {
        index: 0
      };

      jobs_s_r.forEach((subDoc) => {
        jobs_s = subDoc.data();
      });

      this.fire()
        .collection('jobs')
        .add({
          ...form,
          ids_prof: this.form.volumes_prof.map((d) => d.id),
          ids_tech: this.form.volumes_tech.map((d) => d.id),
          work_type: work_type && work_type.value || null,
          work_type_name: work_type && work_type.label || '',
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          unit: this.form.unit.label || null,
          planID: (this.$route.query.plan) || null,
          unit_id: this.form.unit.value || null,
          objects,
          index: jobs_s.index + 1,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Новая работа добавлена',
          type: 'success',
        });
        this.form = {
          name: '',
          plan: '',
          type: '',
          unit: '',
        };
        setTimeout(() => {
          if (!this.isNested) {
            this.$router.go(-1);
          }
          this.$emit('created');
        }, 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.jjobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto 0 auto;
  padding-bottom: 58px;
  box-sizing: border-box;

  .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.jjobs-create {
  .obj-name {
    text-align: left;
    margin-bottom: 10px;
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
}

.jobs-create__buttons {
  position: fixed;
  bottom: 0;
  max-width: 382px;
  width: calc(100% - 40px);
  background: #fff;
  border-top: 1px solid #ccc;
  padding: 10px;
  justify-content: space-between;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/Create.vue